import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/login-screen/components/LoginClient.tsx");
